export const CAF_REQUEST_STATUS = [
  {
    label: 'dashboard.Pending',
    value: 1,
    color: 'warning',
  },
  {
    label: 'dashboard.MissingInfo',
    value: 2,
    color: 'danger',
  },
  {
    label: 'dashboard.InProgress',
    value: 3,
    color: 'blue',
  },
  {
    label: 'dashboard.Completed',
    value: 4,
    color: 'green',
  },
  {
    label: 'Resubmit',
    value: 5,
    color: 'hidden',
  },
  {
    label: 'Stopped',
    value: 6,
    color: 'black',
  },
  {
    label: 'da firmare',
    value: 7,
    color: 'warning',
  },
  {
    label: 'Firmata',
    value: 8,
    color: 'blue',
  },
  {
    label: 'Da Consegnare',
    value: 9,
    color: 'warning',
  },
  {
    label: 'Firma Delaga',
    value: 10,
    color: 'blue',
  },
  {
    label: 'Firma 730',
    value: 11,
    color: 'blue',
  },
  {
    label: 'Bozza',
    value: 12,
    color: 'darkYellow',
  },
  {
    label: 'Da firmare',
    value: 13,
    color: 'warning',
  },
  {
    label: 'Tramesso AdE',
    value: 14,
    color: 'blue',
  },
  {
    label: 'Reddito Presunto',
    value: 15,
    color: 'hidden',
  },
  {
    label: 'Inviato INPS',
    value: 16,
    color: 'warning',
  },
  {
    label: 'Trasmesso AdE',
    value: 17,
    color: 'blue',
  },
]
